/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="inventoryCount.module.ts" />
///<reference path="../../components/short-cuts/models/short-cuts-state-manager.controller.ts"/>
///<reference path="../AppointmentBook/js/controllers/AppointmentBook.ts"/>
let Quagga: QuaggaJSStatic;

module Meevo.Plugins.InventoryCount {
    import IShortCutsService = Meevo.Components.ShortCuts.IShortCutsService;
    import ShortCutsStateManagerController = Meevo.Components.ShortCuts.ShortCutsStateManagerController;
    import MaintenanceFormVisualState = Meevo.Model.MaintenanceFormVisualState;
    import InventoryCountStateEnum = Meevo.Model.InventoryCountStateEnum;

    class InventoryCountController extends ShortCutsStateManagerController {

        closeContext: Function;
        context: InventoryCountContext;
        mobileView: any = 'editCount';

        protected onHandValue: number;
        
        public visualState: MaintenanceFormVisualState;
        protected shortCutGroup: { [key: number]: IShortCutGroup };

        get noun() {
            return Meevo.Model.NounEnum.InventoryCount;
        }

        get mode(): Meevo.Model.MaintenanceFormState {
            return this.context.mode;
        }

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.busy.BusyService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.InventoryRoundingService",
            "$rootScope",
            "$state",
            "$filter",
            "meevo.components.common.SecurityService",
            "$q",
            "$timeout",
            "meevoDateFilterFilter",
            "meevo.components.short-cuts.ShortCutsService",
            "$scope",
            "$mdSidenav",
            "meevo.components.tracking.TrackingService",
            "$mdToast",
            "$translate"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected modalService: Meevo.Components.Modal.ModalService,
                    protected roundingService: Meevo.Components.Common.IInventoryRoundingService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $state: any,
                    protected $filter: angular.IFilterService,
                    protected securityChecker: Meevo.Components.Common.SecurityService,
                    protected $q: ng.IQService,
                    protected $timeout: ng.ITimeoutService,
                    protected meevoDateFilter: any,
                    protected shortCutsService: IShortCutsService,
                    protected $scope: ng.IScope,
                    private $mdSidenav: any,
                    private trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $mdToast: angular.material.IToastService,
                    public $translate: ng.translate.ITranslateService) {
            super($scope, $state, shortCutsService);
            this.visualState = MaintenanceFormVisualState.Search;

            //this.dialog = $mdDialog;
            
            this.onHandValue = 0;
            this.context = new InventoryCountContext(appSettings, dataService, busyService, modalService, roundingService, this, this.securityChecker, $q, $timeout, meevoDateFilter, $state, $filter, $rootScope, $mdSidenav, trackingService, $translate);
            console.log('===================vm.context InventoryCountContext', this.context)
            this.closeContext = (): void => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            }

            this.shortCutGroup = {
                [Meevo.Model.MaintenanceFormState.Readonly]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_ADD',
                    callback: () => {
                        $timeout(() => {
                            $('button[meevo-btn-sc="DATA_MAINTENANCE_ADD"]:visible').click();
                        });
                    }
                }, {
                        shortCutName: 'DATA_MAINTENANCE_EDIT',
                        callback: () => {
                            this.context.edit();
                            this.visualState = MaintenanceFormVisualState.Detail;
                        }
                    }

                ]),
                [Meevo.Model.MaintenanceFormState.Adding]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.context.saveInventoryCount();
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => {
                        this.context.cancel();
                        this.visualState = MaintenanceFormVisualState.Search;
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Editing]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.context.saveInventoryCount();
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => {
                        this.context.cancel();
                        this.visualState = MaintenanceFormVisualState.Search;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_DELETE',
                    callback: () => {
                        this.context.deleteCount();
                    }
                }]),
            };
            $scope.$on("$destroy", () => {
                this.context.closeCustomModal();
            });
            
            this.registerEventListeners();
            
        }

        registerEventListeners = () : void => {
            this.$scope.$on(Meevo.Components.Common.Messages.SYNCHRONIZE_CONVO, (event, contextItem) => {
                if (contextItem.name !== 'inventoryCount') {
                    this.context.closeCustomModal();
                }
            })

            this.$scope.$on(Meevo.Components.Common.Messages.PRODUCT_SAVED, (event, contextItem) => {
                contextItem.variants.forEach((item) => {
                    this.context.barcodeScanResults[0] = this.context.barcodeScanResults[0].filter(x => x !== item.barCode);
                });
            })
    
        }

        viewSwitch = (view: any): void => {
            this.mobileView = view;
        }

        submitCustomModal(): void {
            this.modalService.hideWithResponse(this.onHandValue);
        }
        
    }

    angular.module("meevo.plugins.inventoryCount", ['ngMaterial', 'ui.swiper', 'fixed.table.header'])
        .controller("meevo.plugins.inventoryCount.InventoryCountController", InventoryCountController);
}
